import { alpha } from '@mui/material';
import { palette } from 'assets/styles/colors';
import box from '../radius';

const boxShadowColor = palette.blue[800];
const boxRadius = box.radius.md;

const paper = {
  MuiPaper: {
    styleOverrides: {
      root: {
        padding: '1rem',
        boxShadow: `0 2px 20px ${alpha(boxShadowColor, 0.1)}`,
        borderRadius: boxRadius,
      },
    },
  },
};

export default paper;
